import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalSave extends React.Component {
    render() {
        const { ShowModalSave, CancelHandler, DeleteHandler2, Model, Mode } = this.props

        return (
            <div>
                <Modal show={ShowModalSave} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Success {Mode} Faskes</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Success {Mode} Faskes</p>

                    </Modal.Body>

                    <Modal.Footer>
                         

                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}